import styled from 'styled-components';
import {
  DescriptionHyperLink as DescriptionHyperLinkCommon,
  DescriptionValue,
  TruncatedTitle,
} from '../../ItemCommons/CommonItem.styles';

const DescriptionLabel = styled(TruncatedTitle)`
  -webkit-line-clamp: 1;
`;

const DescriptionBody = styled(DescriptionValue)<{
  showPrice?: boolean;
  showQuantity?: boolean;
  showReasonForReturn?: boolean;
}>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${({ showPrice, showQuantity, showReasonForReturn }) =>
    !showPrice || !showQuantity
      ? 9 - (showReasonForReturn ? 3 : 0)
      : 11 - (showReasonForReturn ? 3 : 0)};
  -webkit-box-orient: vertical;
  margin-top: 8px;
  margin-bottom: 16px;
`;

const ReasonForReturnBody = styled(DescriptionBody)`
  -webkit-line-clamp: 2;
`;

const DescriptionHyperLink = styled(DescriptionHyperLinkCommon)`
  bottom: 22px;
  position: absolute;
`;

export {
  DescriptionLabel,
  DescriptionBody,
  DescriptionHyperLink,
  ReasonForReturnBody,
};
